import React, { FC } from "react";
import { segmentScript } from "services/frontend/Segment";
import Script from "next/script";
import {
  getHeaderFontAsString,
  getBodyFontAsString,
} from "services/shared/Typography";

const HeadTags: FC = () => (
  <>
    <TypographyTag />
    <GlobalStylesTag />
    <CharsetTag />
    <ViewportTag />
    <GoogleSiteVerificationTag />
    <NProgressStylesheetTag />
    <ShortcutIconTag />
  </>
);

// Script tags can not be placed in either a next/head component or in pages/_document.js.
export const ScriptTags: FC = () => (
  <>
    <TwitterPixel />
    <RankScienceTag />
    <SegmentScriptTag />
  </>
);

export default HeadTags;

export function TypographyTag() {
  return (
    <>
      <style>
        {`
                h1, h2, h3, h4, h5, h6 {
                    font-family: ${getHeaderFontAsString()};
                },

                * {
                    font-family: ${getBodyFontAsString()}
                }
            `}
      </style>
    </>
  );
}

export const GlobalStylesTag = () => (
  <style global jsx>{`
    * {
      box-sizing: border-box;
      touch-action: manipulation;
    }

    *:focus {
      outline: none !important;
    }

    html,
    body,
    div#__next {
      height: 100vh;
    }
  `}</style>
);

export const CharsetTag = () => <meta charSet="utf-8" />;

export const ViewportTag = () => (
  <>
    <meta
      name="viewport"
      content="width=device-width, initial-scale=1.0, maximum-scale=5.0, minimum-scale=1.0"
    />
  </>
);

export const GoogleSiteVerificationTag = () => (
  <meta
    name="google-site-verification"
    content="pyGKXSddOW_hyGSbaQ2rgXn5JUJe0LdaUaCPnND1cSc"
  />
);

export const TwitterPixel = () => (
  <Script
    id="twitter-pixel"
    strategy="afterInteractive"
    dangerouslySetInnerHTML={{
      __html: `
        !function(e,t,n,s,u,a){e.twq||(s=e.twq=function(){s.exe?s.exe.apply(s,arguments):s.queue.push(arguments);
        },s.version='1.1',s.queue=[],u=t.createElement(n),u.async=!0,u.src='//static.ads-twitter.com/uwt.js',
        a=t.getElementsByTagName(n)[0],a.parentNode.insertBefore(u,a))}(window,document,'script');
        twq('init','o4pd3');
        twq('track','PageView');`,
    }}
  />
);

export const RankScienceTag = () => (
  <>
    <Script
      id="rankscience-script"
      strategy="afterInteractive"
      src="https://cdn.ranksci.com/thejuggernaut-403909.min.js"
    />
  </>
);

export const NProgressStylesheetTag = () => (
  <link rel="stylesheet" type="text/css" href="/static/nprogress.css" />
);

export const ShortcutIconTag = () => (
  <link
    rel="shortcut icon"
    type="image/x-icon"
    href="/static/lettermark_logo.png"
  />
);

export const SegmentScriptTag = () => (
  <Script
    id="segment-script"
    strategy="afterInteractive"
    dangerouslySetInnerHTML={{
      __html: segmentScript(),
    }}
  />
);
